import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from "moment-timezone";
import Dialog from "@/view/pages/partials/Dialog.vue";
import OneOffScheduleDetail from "@/view/pages/job/partials/One-Off-Schedule.vue";
import { JobScheduleTeamEventBus } from "@/core/lib/job/job.schedule.team.lib";
import { JobEventBus } from "@/core/lib/job/job.lib";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { PUT } from "@/core/services/store/request.module";
import { DialogJobEventBus } from "@/core/lib/job/dialog.job.lib";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return new Object();
      }
    },
    pageLoading: {
      type: Boolean,
      default: false
    },
    visit: {
      type: Number,
      default: 0
    },
    customer: {
      required: true,
      type: Object,
      default: function _default() {
        return new Object();
      }
    },
    property: {
      required: true,
      type: Object,
      default: function _default() {
        return new Object();
      }
    },
    contactPerson: {
      required: true,
      type: Object,
      default: function _default() {
        return new Object();
      }
    },
    dailyRecurrence: {
      type: Object,
      default: function _default() {
        return new Object();
      }
    },
    monthlyRecurrence: {
      type: Object,
      default: function _default() {
        return new Object();
      }
    },
    weeklyRecurrence: {
      type: Object,
      default: function _default() {
        return new Object();
      }
    }
  },
  watch: {
    detail: {
      deep: true,
      immediate: true,
      handler: function handler() {
        if (this.detail.title && !this.visitData.title) {
          this.visitData.title = this.detail.title;
        }
      }
    }
  },
  data: function data() {
    return {
      isInternal: true,
      visitCreated: new Object(),
      assignedEngineers: new Array(),
      OneOffSchedule: new Object(),
      visitScheduleDialog: true,
      ScheduleCreated: false,
      ScheduleEngineerCreated: false,
      formValid: true,
      formLoading: false,
      visitData: {
        title: null,
        instruction: null,
        anytime: 0
      }
    };
  },
  components: {
    Dialog: Dialog,
    OneOffScheduleDetail: OneOffScheduleDetail
  },
  methods: {
    closeDialog: function closeDialog() {
      DialogJobEventBus.$emit("close:add-visit-dialog", true);
    },
    CreateJobSchedule: function CreateJobSchedule(_ref) {
      var job = _ref.job,
          schedule = _ref.schedule,
          team = _ref.team;

      var _this = this;

      return new Promise(function (resolve, reject) {
        try {
          if (_this.lodash.isEmpty(schedule) === false && moment(schedule.start_date).isValid()) {
            _this.$store.dispatch(PUT, {
              url: "job/" + job + "/visit",
              data: {
                title: _this.visitData.title,
                instruction: _this.visitData.instruction || null,
                anytime: _this.lodash.toSafeInteger(_this.visitData.anytime) || 0,
                start_date: schedule.start_date ? moment(schedule.start_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                start_time: schedule.start_time ? moment(schedule.start_time, ["h:mm A"]).format("HH:mm") : moment().startOf("day").format("HH:mm"),
                end_date: schedule.end_date ? moment(schedule.end_date).format("YYYY-MM-DD") : moment(schedule.start_date).format("YYYY-MM-DD"),
                end_time: schedule.end_time ? moment(schedule.end_time, ["h:mm A"]).format("HH:mm") : moment().endOf("day").format("HH:mm"),
                email: team.email_team
              }
            }).then(function (response) {
              resolve(response.data);
            }).catch(function (error) {
              reject(error);
            });
          } else {
            reject("Invalid Start Date in Schedule.");
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    AssignTeam: function AssignTeam(_ref2) {
      var job = _ref2.job,
          visit = _ref2.visit,
          team = _ref2.team;

      var _this = this;

      return new Promise(function (resolve, reject) {
        try {
          if (_this.lodash.isEmpty(team.assigned_team) === false && _this.lodash.isArray(team.assigned_team)) {
            _this.$store.dispatch(PUT, {
              url: "job/" + job + "/visit/" + visit + "/engineer",
              data: {
                engineer: team.assigned_team
              }
            }).then(function (response) {
              resolve(response.data);
            }).catch(function (error) {
              reject(error);
            });
          } else {
            resolve(true);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    updateOrCreate: function updateOrCreate() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this2;

                if (_this.$refs.visitForm.validate()) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", false);

              case 3:
                _this.formLoading = true;

                if (!(!_this.ScheduleCreated && _this.lodash.isEmpty(_this.detail) === false)) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 5;
                _context.next = 8;
                return _this.CreateJobSchedule({
                  job: _this.detail.id,
                  schedule: _this.OneOffSchedule,
                  team: _this.assignedEngineers
                });

              case 8:
                _this.visitCreated = _context.sent;
                _this.ScheduleCreated = true;
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);

                _this.logError(_context.t0);

                _this.ScheduleCreated = false;
                ErrorEventBus.$emit("update:error", InitializeError("Schedule is not created. Please try again."));

              case 17:
                if (!(_this.lodash.isEmpty(_this.assignedEngineers) === false && !_this.ScheduleEngineerCreated && _this.lodash.isEmpty(_this.detail) === false)) {
                  _context.next = 28;
                  break;
                }

                _context.prev = 18;
                _context.next = 21;
                return _this.AssignTeam({
                  job: _this.detail.id,
                  visit: _this.visitCreated.id,
                  team: _this.assignedEngineers
                });

              case 21:
                _this.ScheduleEngineerCreated = true;
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t1 = _context["catch"](18);
                _this.ScheduleEngineerCreated = false;
                ErrorEventBus.$emit("update:error", InitializeError("Engineer are not allocated to Schedule. Please try again."));

              case 28:
                _this.formLoading = false;

                if (_this.lodash.isEmpty(_this.visitCreated) === false) {
                  DialogJobEventBus.$emit("load:job", true);
                  DialogJobEventBus.$emit("load:visit", true);

                  _this.closeDialog();
                }

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 12], [18, 24]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    /*JobScheduleTeamEventBus.$off("get:skills");
    JobScheduleTeamEventBus.$off("update:assigned-team");
    JobEventBus.$off("update:one-off-schedule");*/
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    JobScheduleTeamEventBus.$on("get:skills", function () {
      JobScheduleTeamEventBus.$emit("update:skills", _this.detail.ticket_type);
    });
  },
  created: function created() {
    var _this = this;

    JobScheduleTeamEventBus.$on("update:assigned-team", function (argument) {
      _this.assignedEngineers = argument;
    });
    JobEventBus.$on("update:one-off-schedule", function (argument) {
      _this.OneOffSchedule = argument;
    });
  },
  computed: {
    dialogWidth: function dialogWidth() {
      return this.lodash.toSafeInteger(document.body.clientWidth / 100 * 75);
    },
    PropertyDetail: function PropertyDetail() {
      var propertyArr = new Array();

      if (this.lodash.isEmpty(this.property) === false) {
        if (this.property.unit_no) {
          propertyArr.push(this.property.unit_no);
        }

        if (this.property.street_1) {
          propertyArr.push(this.property.street_1);
        }

        if (this.property.street_2) {
          propertyArr.push(this.property.street_2);
        }

        if (this.property.zip_code) {
          propertyArr.push(this.property.zip_code);
        }

        if (this.CityName) {
          propertyArr.push(this.CityName);
        }

        if (this.StateName) {
          propertyArr.push(this.StateName);
        }

        if (this.CountryName) {
          propertyArr.push(this.CountryName);
        }
      }

      return propertyArr.join(", ");
    },
    CityName: function CityName() {
      return this.lodash.isEmpty(this.property.city) === false ? this.property.city.name : null;
    },
    StateName: function StateName() {
      return this.lodash.isEmpty(this.property.state) === false ? this.property.state.name : null;
    },
    CountryName: function CountryName() {
      return this.lodash.isEmpty(this.property.country) === false ? this.property.country.name : null;
    }
  }
};